import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["field"];

  change(e){
    this.fieldTarget.style.height = `${this.fieldTarget.scrollHeight + 2}px`;
  }
}
